import { render, staticRenderFns } from "./TermsServicePopup.vue?vue&type=template&id=9c2f192c&scoped=true"
import script from "./TermsServicePopup.vue?vue&type=script&lang=js"
export * from "./TermsServicePopup.vue?vue&type=script&lang=js"
import style0 from "./TermsServicePopup.vue?vue&type=style&index=0&id=9c2f192c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2f192c",
  null
  
)

export default component.exports